import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit, AfterViewInit, OnDestroy {

  expandMenu = false;
  public static standard: NavBarOptions =
    { linkTextColor: '#5e5e5e', scroll: false, boxShadow: true, navBackgroundColor: 'white' }
  linkStyle = { 'color': '#fff' }
  navStyle = { 'background-color': 'background-color: rgba(0, 0, 0, 0.0)', 'box-shadow': 'none' }

  @Input() options: NavBarOptions;



  constructor(private router: Router) {

  }

  toggle(){
    this.expandMenu = !this.expandMenu;
  }
  ngOnDestroy(): void {
    window.removeEventListener('scroll', function () {

    });
  }
  ngAfterViewInit(): void {
    window.removeEventListener('scroll', function () {

    });
  }

  onCorporateHover(){
     
  }

  ngOnInit() {
    if(window.outerWidth <= 820){
      this.options = NavBarComponent.standard;
      var navbar = document.getElementById('navbar');
      navbar.style.backgroundColor = 'rgb(255,255,255,0.99)'; // Change to white background
      navbar.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)'; // Optional: Add box shadow
      this.linkStyle.color = "#5e5e5e";
      //this.enableScroll();
      return;
    }
    if (this.options) {
      if (this.options.linkTextColor) {
        this.linkStyle.color = this.options.linkTextColor;
      }
      if (this.options.navBackgroundColor) {
        this.navStyle['background-color'] = this.options.navBackgroundColor;
      }
      if (this.options.boxShadow) {
        this.navStyle['box-shadow'] = '0 2px 5px rgba(0, 0, 0, 0.1)';
      }
    }
    if (this.options) {
      if (this.options.scroll) {
        this.enableScroll();
      }
    } else {
      this.enableScroll();
    }
  }

  navigate(path) {
    window.location.href = `${environment.SITE_URL}${path}`;
    //this.router.navigate([path]);
  }

  enableScroll() {
    let THIS = this;
    window.addEventListener('scroll', function () {
      var navbar = document.getElementById('navbar');
      if (navbar) {
        if (window.scrollY > 10) {
          navbar.style.backgroundColor = 'rgb(255,255,255,0.99)'; // Change to white background
          navbar.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)'; // Optional: Add box shadow
          THIS.linkStyle.color = "#5e5e5e";
        } else {
          navbar.style.backgroundColor = 'transparent'; // Change back to transparent background
          navbar.style.boxShadow = 'none'; // Remove box shadow
          THIS.linkStyle.color = 'white';
        }
      }
    });
  }

}


export interface NavBarOptions {

  scroll: boolean,
  linkTextColor: string;
  navBackgroundColor: string;
  boxShadow: boolean;

}